import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWindsurfNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.847.825h2.649l.915 1.793a18.345 18.345 0 01.001 17.191l-1.008 2.016h6.586l-.72 1.35H2.01l.72-1.35h11.223l-.046-.023.412-.825-8.198-3.802h-2.72v-1.35H4.87l7.977-15zM9.33 17.175l5.593 2.594.29-.578.003-.008c.346-.65.648-1.322.905-2.008H9.33zm7.233-1.35H6.419l-.016-.007 1.937-3.643h8.833a16.992 16.992 0 01-.61 3.65zm-7.505-5h8.137a17 17 0 00-.482-3.65h-5.714l-1.941 3.65zm2.659-5h4.606a16.996 16.996 0 00-1.107-2.579l-.005-.01-.542-1.061h-1.011l-1.941 3.65z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWindsurfNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsWindsurfNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWindsurfNormalSmall;
